// extracted by mini-css-extract-plugin
export default {"news":"style_news__tUoFs","newsItem":"style_newsItem__ackrN","content":"style_content__C7SK1","title":"style_title__i5fw-","date":"style_date__YgE6M"};